import { useCallback, useEffect, useRef, useState } from 'react';
import { GetTask } from '@core/api/endpoints/task/get_task';
import { referenceScope } from '@/features/references/cache';
import { TaskDetailRequest, taskDetailKey, type TaskDetailSnapshot } from './taskDetailRequest';

export function useTaskDetail(id?: string) {
  const scope = referenceScope();
  const key = taskDetailKey(id || '', scope);
  const [snapshot, setSnapshot] = useState<TaskDetailSnapshot>({ key: '', task: null, loading: false, error: null });
  const request = useRef<TaskDetailRequest>();
  if (!request.current) request.current = new TaskDetailRequest(async (taskId) => (await GetTask(taskId)).task || null, setSnapshot);
  const reload = useCallback(() => id ? request.current!.load(id, scope) : Promise.resolve(), [id, scope]);
  useEffect(() => { void reload(); return () => request.current!.cancel(); }, [reload]);
  const clearError = useCallback(() => request.current!.clearError(), []);
  const matches = snapshot.key === key;
  return { key, task: matches ? snapshot.task : null, isLoading: !!id && (!matches || snapshot.loading), error: matches ? snapshot.error : null, reload, clearError };
}
